import type { MySettings, OnboardingOutcome, SettingsPatch, SettingsSaved } from '../types/domain.types';

import { CTL_ENDPOINTS } from './endpoints';
import { request } from './http';
import { mySettingsSchema, parseOrThrow, settingsSavedSchema } from './schemas';

interface OnboardingPatch {
  readonly onboarding: OnboardingOutcome;
}

const saveMine = async (body: SettingsPatch | OnboardingPatch): Promise<SettingsSaved> => {
  const raw = await request('patch', CTL_ENDPOINTS.SETTINGS_ME, { body });
  const { notified, ...settings } = parseOrThrow(settingsSavedSchema, raw, 'settings');
  return { settings, notified };
};

export const fetchMySettings = async (signal: AbortSignal | undefined): Promise<MySettings> => {
  const raw = await request('get', CTL_ENDPOINTS.SETTINGS_ME, { signal });
  return parseOrThrow(mySettingsSchema, raw, 'settings');
};

export const updateMySettings = (patch: SettingsPatch): Promise<SettingsSaved> => saveMine(patch);

export const completeOnboarding = async (outcome: OnboardingOutcome): Promise<MySettings> =>
  (await saveMine({ onboarding: outcome })).settings;
